import loadable from '@loadable/component';
import Loading from '../../components/Loader';
import { fetchCategoryFromKey, fetchCategorySuggestionsFromKey } from '../../actions/category';
import { fetchModalQuestions } from '../../actions/questions';

const GQProjects = loadable(() => import('./index'), {
  fallback: Loading
});

GQProjects.needs = async (props, { dispatch }) => {
  const category = props.params.category;
  const displayCategory = dispatch(fetchCategoryFromKey(category));
  const modalQuestions = dispatch(fetchModalQuestions(category));
  const recommendedCategories = dispatch(fetchCategorySuggestionsFromKey(category));
  return await Promise.all([displayCategory, modalQuestions, recommendedCategories]);
};

export default GQProjects;
